<div class="booking-editor">
  <!-- Estimator Fields from Discount -->
  <div class="booking-editor__estimator mb-2" *ngIf="filter">
    <div class="estimator-accordion">
      <div class="estimator-accordion__header" (click)="showEstimatorSettings = !showEstimatorSettings">
        <div class="estimator-accordion__title">
          <i class="fa-solid fa-calculator me-2"></i>
          Estimator Settings
        </div>
        <i class="fa-solid estimator-accordion__icon" 
           [class.fa-chevron-down]="!showEstimatorSettings" 
           [class.fa-chevron-up]="showEstimatorSettings"></i>
      </div>
      <div class="estimator-accordion__content" [class.estimator-accordion__content--expanded]="showEstimatorSettings">
        <div class="estimator-accordion__body">
          <div class="form-group">
            <label class="form-label">Estimator Title</label>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="estimatorTitle" 
              placeholder="Enter estimator title" />
          </div>
          <div class="form-group">
            <label class="form-label">Estimator Description</label>
            <textarea 
              rows="3" 
              class="form-control" 
              [(ngModel)]="estimatorDescription" 
              placeholder="Enter estimator description"></textarea>
          </div>
          <div class="form-group">
            <button class="btn btn-sm btn-primary" (click)="saveEstimator()">
              <i class="fa-solid fa-save mr-1"></i>
              Save Estimator Settings
            </button>
          </div>
          <!-- Super Groups View -->
          <app-upload-popup-image [filter]="filter" [type]="'estimator'"></app-upload-popup-image>
        </div>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="column card-view" *ngIf="!selectedSuperGroup">
      <div class="card-header">
        <div>
          <h3 class="card-title">
            <i class="fa fa-folder-open"></i>
            <span>Variable Groups</span>
            <input [(ngModel)]="superGroupsTitle" (keyup)="changeCategoryBookingProperty('customSuperGroupsName', $event.target.value)" class="form-control modern-input mr-2" type="text" placeholder="Custom Groups Title" />
          </h3>
          <p class="card-subtitle">Manage your booking variable groups</p>
        </div>
      </div>

      <div class="card-body">
        <div class="add-form">
          <div class="form-group">
            <input type="text" class="form-control modern-input" placeholder="Enter new group title" [(ngModel)]="newSuperGroupTitle" (keydown.enter)="addSuperGroup()" />
          </div>
          <div class="form-group">
            <input type="text" class="form-control modern-input" placeholder="Enter new group proximity rebate" [(ngModel)]="newSuperGroupProximityRebateValue" (keydown.enter)="addSuperGroup()" />
          </div>
          <button class="btn btn-primary" style="margin-left: auto; display: flex" (click)="addSuperGroup()"><i class="fa fa-plus"></i> Add Group</button>
        </div>

        <div class="list-container">
          <div class="list" *ngIf="superGroups.length > 0; else emptyState">
            <div class="list-item card-item" *ngFor="let g of superGroups" [class.selected]="selectedSuperGroup?.id === g.id" (click)="selectSuperGroup(g)">
              <div class="label-select mr-3" (click)="$event.stopPropagation()">              


                <select (change)="setListView(g, $event.target.value)">
                  <option [selected]="g.listView == opt || (!g.listView && i == 0)"  *ngFor="let opt of ['Default', 'Grid', 'List View']; index as i" [value]="opt">{{opt}}</option>
                </select>
              </div>
              <div class="item-content">
                <i class="fa fa-folder item-icon"></i>
                <span *ngIf="!g._editing" class="item-title">{{ g.title }}</span>
                <input *ngIf="g._editing" class="inline-edit-input" [(ngModel)]="g.title" (keydown.enter)="saveSuperGroup(g, $event)" (blur)="handleSuperGroupBlur(g)" (click)="$event.stopPropagation()" />
                <input *ngIf="g._editing" class="inline-edit-input" [(ngModel)]="g.proximityRebateValue" (keydown.enter)="saveSuperGroup(g, $event)" (blur)="handleSuperGroupBlur(g)" (click)="$event.stopPropagation()" placeholder="proximity rebate" />
              </div>
              <div class="item-actions" (click)="$event.stopPropagation()">
                <button class="btn-icon btn-secondary" (click)="refreshSuperGroup(g)" *ngIf="!g._editing"><i class="fa fa-rotate"></i></button>
                <button class="btn-icon btn-secondary" *ngIf="!g._editing" (click)="startEditSuperGroup(g); $event.stopPropagation()" title="Edit">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="btn-icon btn-success" *ngIf="g._editing" (click)="g._skipBlurSave = true; saveSuperGroup(g); $event.stopPropagation()" title="Save">
                  <i class="fa fa-save"></i>
                </button>
                <button class="btn-icon btn-danger" (click)="deleteSuperGroup(g)" title="Delete">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <ng-template #emptyState>
            <div class="empty-state">
              <i class="fa fa-inbox"></i>
              <p>No groups yet. Create your first group above.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Groups View -->
    <div class="column card-view" *ngIf="!selectedGroup && selectedSuperGroup">
      <div class="card-header">
        <button class="back-btn" (click)="selectedSuperGroup = null">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div class="header-content">
          <h3 class="card-title">
            <i class="fa fa-layer-group"></i>
            <span>Sub Groups </span> <input [(ngModel)]="groupsTitle" (keyup)="changeCategoryBookingProperty('customGroupsName', $event.target.value)" class="form-control modern-input mr-2" type="text" placeholder="Custom Sub Groups Title" />
          </h3>
          <p class="card-subtitle">
            Group: <strong>{{ selectedSuperGroup.title }}</strong>
          </p>
        </div>
      </div>

      <div class="card-body">
        <div class="add-form">
          <div class="form-row">
            <div class="form-group">
              <input type="text" class="form-control modern-input" placeholder="New group title" [(ngModel)]="newGroupTitle" (keydown.enter)="addGroup()" />
            </div>
            <div class="form-group">
              <input type="number" class="form-control modern-input" placeholder="Value" [(ngModel)]="newGroupValue" (keydown.enter)="addGroup()" />
            </div>
            <div class="form-group">
              <input type="number" class="form-control modern-input" placeholder="Max Value" [(ngModel)]="newGroupMaxValue" (keydown.enter)="addGroup()" />
            </div>

            <div class="form-group">
              <input type="text" class="form-control modern-input" placeholder="Short Description" [(ngModel)]="newGroupDescr" (keydown.enter)="addGroup()" />
            </div>

             <div class="form-group">
              <input type="text" class="form-control modern-input" placeholder="Short Description 2" [(ngModel)]="newGroupDescr2" (keydown.enter)="addGroup()" />
            </div>
          </div>
          <button class="btn btn-primary" style="margin-left: auto; display: flex" (click)="addGroup()"><i class="fa fa-plus"></i> Add Sub Group</button>
        </div>

        <div class="list-container">
          <div class="list" *ngIf="groups.length > 0; else emptyState">
            <div *ngFor="let g of groups" class="row align-items-center px-2 justify-content-center ">
              <input type="file" [id]="'selectNewGroupImage-' +g.id " class="d-none" (change)="setNewGroupImage($event, g)" />
              <button  *ngIf="!g.image" class="t-btn  col-sm-12 col-md-5 " style="z-index: 100; max-width: 30%;" (click)="selectGroupImage($event, g)">
                <i class="fa fa-tags item-icon"></i>
              </button>


              <img *ngIf="g.image" [src]="imgUrl + g.image" class="col-sm-12 col-md-5" style="max-width: 30%; margin-top: 1rem;" (click)="selectGroupImage($event, g)"/>
              <div class="list-item card-item col-sm-12 col-md-7" [class.selected]="selectedGroup?.id === g.id" (click)="selectGroup(g)">
                <div class="item-content d-grid">

            
                 
                  <span *ngIf="!g._editing" class="item-title">{{ g.title }}</span>
                  <span *ngIf="!g._editing" class="item-badge">Short Descr 1: {{ g.descr }}</span>
                  <span *ngIf="!g._editing" class="item-badge">Short Descr 2:  {{ g.descr2 }}</span>
                  <input *ngIf="g._editing" class="inline-edit-input group-input" [(ngModel)]="g.title" [attr.data-group-id]="g.id" (keydown.enter)="saveGroup(g, $event)" (blur)="handleGroupBlur(g, $event)" (click)="$event.stopPropagation()" placeholder="Group title" />

                  <span class="item-badge mr-1" *ngIf="!g._editing && g.value !== null && g.value !== undefined"> Value: {{ g.value }} </span>
                  <span class="item-badge mr-1" *ngIf="!g._editing && g.value !== null && g.value !== undefined"> Max Value: {{ g.maxValue ?? "-" }} </span>

                  <input *ngIf="g._editing && g._hasValueField" type="text" 
                  class="inline-edit-input group-input " [(ngModel)]="g.descr" [attr.data-group-id]="g.id" 
                  (keydown.enter)="saveGroup(g, $event)" (blur)="handleGroupBlur(g, $event)" (click)="$event.stopPropagation()" placeholder="Short Description" />
                
                  <input *ngIf="g._editing && g._hasValueField" type="text" 
                  class="inline-edit-input group-input " [(ngModel)]="g.descr2" [attr.data-group-id]="g.id" 
                  (keydown.enter)="saveGroup(g, $event)" (blur)="handleGroupBlur(g, $event)" (click)="$event.stopPropagation()" placeholder="Short Description 2" />

                  <input *ngIf="g._editing && g._hasValueField" type="number" class="inline-edit-input group-input " [(ngModel)]="g.value" [attr.data-group-id]="g.id" (keydown.enter)="saveGroup(g, $event)" (blur)="handleGroupBlur(g, $event)" (click)="$event.stopPropagation()" placeholder="Value" />

                  <input *ngIf="g._editing && g._hasValueField" type="number" class="inline-edit-input group-input " [(ngModel)]="g.maxValue" [attr.data-group-id]="g.id" (keydown.enter)="saveGroup(g, $event)" (blur)="handleGroupBlur(g, $event)" (click)="$event.stopPropagation()" placeholder="Max Value" />

                  <span class="item-badge mr-1">order: {{ g.order }}</span>
                  <div class="d-flex">
                    <button class="t-btn mr-2" (click)="$event.stopPropagation(); addToSubGroup(g, -1)"><i class="fa fa-arrow-up"></i></button>
                    <button class="t-btn mr-2" (click)="$event.stopPropagation(); addToSubGroup(g, 1)"><i class="fa fa-arrow-down"></i></button>
                  </div>
                </div>
                <div class="item-actions" (click)="$event.stopPropagation()">
                  <button class="btn-icon btn-secondary" (click)="cloneSubGroup(g)" *ngIf="!g._editing"><i class="fa-solid fa-copy"></i></button>

                  <button class="btn-icon btn-secondary" *ngIf="!g._editing" (click)="editGroup(g); $event.stopPropagation()" title="Edit">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button class="btn-icon btn-success" *ngIf="g._editing" (click)="g._skipBlurSave = true; saveGroup(g); $event.stopPropagation()" title="Save">
                    <i class="fa fa-save"></i>
                  </button>
                  <button class="btn-icon btn-danger" (click)="deleteGroup(g)" title="Delete">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ng-template #emptyState>
            <div class="empty-state">
              <i class="fa fa-inbox"></i>
              <p>No sub groups yet. Create your first sub group above.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Variables View -->
    <div class="column card-view" *ngIf="selectedGroup && !selectedVariable">
      <div class="card-header">
        <button class="back-btn" (click)="selectedGroup = null">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div class="header-content">
          <h3 class="card-title">
            <i class="fa fa-list"></i>
            <span>Variables</span>

            <input [(ngModel)]="variablesTitle" (keyup)="changeCategoryBookingProperty('customVariablesName', $event.target.value)" class="form-control modern-input mr-2" type="text" placeholder="Custom  Variables Title" />
          </h3>
          <p class="card-subtitle">
            Group: <strong>{{ selectedGroup.title }}</strong>
          </p>
        </div>
      </div>

      <div class="card-body">
        <div class="add-form">
          <div class="form-group">
            <input type="text" class="form-control modern-input" placeholder="New variable title" [(ngModel)]="newVariableTitle" (keydown.enter)="addVariable()" />
          </div>
          <button class="btn btn-primary" (click)="addVariable()"><i class="fa fa-plus"></i> Add Variable</button>
        </div>

        <div class="list-container">
          <div class="list" *ngIf="selectedGroup.bookingVariables?.length > 0; else emptyState">
            <div class="list-item card-item" *ngFor="let v of selectedGroup.bookingVariables" [class.selected]="selectedVariable?.id === v.id" (click)="selectVariable(v)">
              <div class="item-content">
                <i class="fa fa-tag item-icon"></i>
                <span *ngIf="!v._editing" class="item-title">{{ v.title }}</span>
                <input *ngIf="v._editing" class="inline-edit-input variable-input" [(ngModel)]="v.title" [attr.data-variable-id]="v.id" (keydown.enter)="saveVariable(v, $event)" (blur)="handleVariableBlur(v, $event)" (click)="$event.stopPropagation()" placeholder="Variable title" />
              </div>
              <div class="item-actions" (click)="$event.stopPropagation()">
                <button class="btn-icon btn-secondary" *ngIf="!v._editing" (click)="editVariable(v); $event.stopPropagation()" title="Edit">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="btn-icon btn-success variable-action" *ngIf="v._editing" [attr.data-variable-id]="v.id" (click)="v._skipBlurSave = true; saveVariable(v); $event.stopPropagation()" title="Save">
                  <i class="fa fa-save"></i>
                </button>
                <button class="btn-icon btn-danger" (click)="deleteVariable(v)" title="Delete">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <ng-template #emptyState>
            <div class="empty-state">
              <i class="fa fa-inbox"></i>
              <p>No variables yet. Create your first variable above.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Sub Variables View -->
    <div class="column card-view" *ngIf="selectedVariable">
      <div class="card-header">
        <button class="back-btn" (click)="selectedVariable = null">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div class="header-content">
          <h3 class="card-title">
            <i class="fa fa-list-ul"></i>
            <span>Sub-variables</span>
            <input [(ngModel)]="subVariablesTitle" (keyup)="changeCategoryBookingProperty('customSubVariablesName', $event.target.value)" class="form-control modern-input mr-2" type="text" placeholder="Custom Variables Title" />
          </h3>
          <p class="card-subtitle">
            Variable: <strong>{{ selectedVariable.title }}</strong>
          </p>
        </div>
      </div>

      <div class="card-body">
        <div class="add-form">
          <div class="add-form__content">
            <div>
              <div class="image-upload-preview" (click)="subVariableFile?.click()">
                @if (newSubVariableImage.fileUrl) {
                  <img [src]="newSubVariableImage.fileUrl" alt="Preview" />
                  <div class="image-overlay">
                    <i class="fa fa-camera"></i>
                    <span>Change Image</span>
                  </div>
                } @else {
                  <div class="image-placeholder">
                    <i class="fa fa-cloud-upload-alt"></i>
                    <span>Click to upload image</span>
                  </div>
                }
              </div>
              <input type="file" accept="image/*" class="d-none" #subVariableFile (change)="setNewSubVariableImage($event)" />
            </div>

            <div>
              <div class="form-group">
                <input type="text" class="form-control modern-input" placeholder="New sub variable title" [(ngModel)]="newSubVariableTitle" (keydown.enter)="addSubVariable()" />
              </div>

              <div class="d-flex" style="gap: 0.5rem">
                <div class="form-group">
                  <input type="number" class="form-control modern-input" [(ngModel)]="newSubVariableAmount.amount" placeholder="Amount" (keydown.enter)="addSubVariable()" />
                </div>
                <div class="checkbox-group">
                  <label class="checkbox-label">
                    <input type="checkbox" class="modern-checkbox" [checked]="newSubVariableAmount.isPercent" (change)="newSubVariableAmount.isPercent = $event.target.checked" />
                    <span>Is Percentage</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <button class="btn btn-primary btn-block" (click)="addSubVariable()"><i class="fa fa-plus"></i> Add Sub Variable</button>
        </div>

        <div class="list-container">
          <div class="list" *ngIf="selectedVariable.bookingSubVariables?.length > 0; else emptyState">
            <div class="sub-item card-item" *ngFor="let s of selectedVariable.bookingSubVariables">
              <div class="item-content">
                <div class="sub-item-image" [class.invisible]="!s.imagePath">
                  <img [src]="imgUrl + s.imagePath" alt="{{ s.title }}" />
                </div>
                <div class="sub-item-info">
                  <ng-container *ngIf="!s._editing; else subVariableEditTemplate">
                    <span class="item-title">{{ s.title }}</span>
                    <span class="item-meta" *ngIf="s.amount"> {{ s.amount }}{{ s.isPercent ? "%" : "" }} </span>
                  </ng-container>
                </div>
              </div>
              <span class="item-badge mr-1">order: {{ s.order }}</span>
              <div class="item-actions">
                <div class="d-flex">
                  <button class="t-btn mr-2" (click)="$event.stopPropagation(); addToSubVar(s, -1)"><i class="fa fa-arrow-up"></i></button>
                  <button class="t-btn mr-2" (click)="$event.stopPropagation(); addToSubVar(s, +1)"><i class="fa fa-arrow-down"></i></button>
                </div>
                <button class="btn-icon btn-secondary" *ngIf="!s._editing" (click)="editSubVariable(s); $event.stopPropagation()" title="Edit">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="btn-icon btn-success sub-variable-action" *ngIf="s._editing" [attr.data-sub-variable-id]="s.id" (click)="s._skipBlurSave = true; saveSubVariable(s); $event.stopPropagation()" title="Save">
                  <i class="fa fa-save"></i>
                </button>
                <button class="btn-icon btn-danger" (click)="deleteSubVariable(s)" title="Delete">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <ng-template #emptyState>
            <div class="empty-state">
              <i class="fa fa-inbox"></i>
              <p>No sub variables yet. Create your first sub variable above.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <ng-template #subVariableEditTemplate>
      <div class="sub-variable-edit">
        <input class="inline-edit-input sub-variable-input" [(ngModel)]="s.title" placeholder="Sub variable title" [attr.data-sub-variable-id]="s.id" (keydown.enter)="saveSubVariable(s, $event)" (blur)="handleSubVariableBlur(s, $event)" (click)="$event.stopPropagation()" />
        <div class="sub-variable-edit-row">
          <input type="number" class="inline-edit-input sub-variable-input sub-variable-amount" [(ngModel)]="s.amount" [ngModelOptions]="{ standalone: true }" [attr.data-sub-variable-id]="s.id" (keydown.enter)="saveSubVariable(s, $event)" (blur)="handleSubVariableBlur(s, $event)" (click)="$event.stopPropagation()" placeholder="Amount" />
          <label class="checkbox-label sub-variable-input" [attr.data-sub-variable-id]="s.id">
            <input type="checkbox" class="modern-checkbox sub-variable-input" [attr.data-sub-variable-id]="s.id" [(ngModel)]="s.isPercent" [ngModelOptions]="{ standalone: true }" (blur)="handleSubVariableBlur(s, $event)" (click)="$event.stopPropagation()" />
            <span>Is Percentage</span>
          </label>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="booking-editor__banner">
    <span class="booking-editor__banner-title">Banner:</span>
    <input type="file" class="d-none" #selectBannerImage (change)="setBanner($event)" />
    <button class="delete-btn t-btn" *ngIf="selectedBannerImageURL || typeOrCategoryData.variablesBanner" (click)="selectedBannerImageURL = ''; selectedBannerImage = null; setCategoryVariableBanner()"><i class="fa fa-trash"></i></button>
    @if (selectedBannerImageURL) {
      <img [src]="selectedBannerImageURL" (click)="selectBannerImage.click()" />
    } @else if (typeOrCategoryData?.variablesBanner) {
      <img [src]="imgUrl + typeOrCategoryData.variablesBanner" (click)="selectBannerImage.click()" />
    } @else {
      <!-- <img src="./../assets/images/uploadd2.png" (click)="selectBannerImage.click()"/> -->
      <div class="image-upload-preview" (click)="selectBannerImage?.click()">
        <div class="image-placeholder">
          <i class="fa fa-cloud-upload-alt"></i>
          <span>Click to upload image</span>
        </div>
      </div>
    }
  </div>
</div>
